<template>
  <div class="inline-select flex">
    <select
      :class="{
        'is-empty': value === '',
      }"
      v-bind="$attrs"
      @change="onSelect($event)"
    >
      <option v-if="placeholder" disabled value="" selected>
        {{ placeholder }}
      </option>

      <template :key="key" v-for="(option, key) in options">
        <option
          v-if="typeof option === 'object'"
          :value="option.value"
          v-bind="options.attrs"
          :disabled="option.disabled"
          :selected="option === value"
          :data-key="key"
        >
          {{ option.label || option.value }}
        </option>
        <option
          v-else
          :value="option"
          :selected="option === value"
          :data-key="key"
        >
          {{ option }}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: "Select",
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Object],
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onSelect(e) {
      const optIndex = e.target.selectedOptions[0].dataset.key;
      const option = this.options[optIndex];

      if (option !== undefined) {
        const optValue = option.value !== undefined ? option.value : option;
        this.$emit("update", optValue);
      }
    },
  },
};
</script>
